import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TuiLet } from '@taiga-ui/cdk';
import {
  TuiIslandDirective,
  TuiTextfieldControllerModule,
  TuiTextareaModule,
  TuiInputModule,
  TuiInputNumberModule,
  TuiSelectModule,
} from '@taiga-ui/legacy';
import { TuiDataList, TuiGroup, TuiButton, TuiError } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ComponentsModule } from '@src/app/components';
import { InputFilesModule } from '@src/app/modules/input-files';

import { ContactsComponent } from './contacts.component';
import {
  ContactsSortOrderComponent,
  ContactsTypeComponent,
  ContactsNameComponent,
  ContactsValueFileComponent,
  ContactsValueTextComponent,
  ContactsValueTextareaComponent,
  ContactsViewOldComponent,
} from './components';

@NgModule({
  declarations: [
    ContactsComponent,
    ContactsNameComponent,
    ContactsSortOrderComponent,
    ContactsTypeComponent,
    ContactsValueFileComponent,
    ContactsValueTextComponent,
    ContactsValueTextareaComponent,
    ContactsViewOldComponent,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    ReactiveFormsModule,
    TuiInputModule,
    TuiInputNumberModule,
    TuiTextfieldControllerModule,
    TuiSelectModule,
    ...TuiDataList,
    TuiTextareaModule,
    TuiIslandDirective,
    TuiButton,
    TuiLet,
    TuiGroup,
    TranslateModule,
    NgxPermissionsModule,
    InputFilesModule,
    TuiError,
  ],
  exports: [ContactsComponent],
})
export class ContactsModule {}
